import { isOptionalValueCrdtAlgorithm } from './interfaces/CrdtAlgorithmOptionalValue.js';
import { isReferenceToObjectCrdtAlgorithm } from './interfaces/CrdtAlgorithmReferenceToObject.js';
import { isStandardCrdtAlgorithm } from './interfaces/CrdtAlgorithmStandard.js';
import { createMessageBus } from '../message-bus.js';
import { iterateObjectsMerge } from '../util/iterate-objects-merge.js';
import { calculateIdHashOfObj } from '../util/object.js';
import { VersionTree } from './VersionTree.js';
const MessageBus = createMessageBus('mergeObjects');
export async function mergeObjects(firstNodeHash, secondNodeHash, type) {
    MessageBus.send('log', `merge version nodes ${firstNodeHash} and ${secondNodeHash} of type ${type}`);
    const tree = await VersionTree.constructVersionTreeUntilCommonHistory(firstNodeHash, secondNodeHash);
    if (tree.firstMergeNode.hash === tree.secondMergeNode.hash) {
        const obj = tree.firstMergeNode.data;
        const hash = tree.firstMergeNode.obj.data;
        const idHash = (await calculateIdHashOfObj(obj));
        return {
            alreadyMerged: true,
            result: {
                obj,
                hash,
                idHash,
                status: 'exists',
                timestamp: undefined
            },
            newNodeHash: tree.firstMergeNode.hash,
            tree
        };
    }
    const result = await iterateObjectsMerge(type, tree, {
        string: standardMerge,
        integer: standardMerge,
        number: standardMerge,
        boolean: standardMerge,
        async referenceToObj(args) {
            MessageBus.send('debug', `merge ${args.path} [referenceToObj] with algorithm ${args.crdtAlgorithm.id}`);
            if (isReferenceToObjectCrdtAlgorithm(args.crdtAlgorithm)) {
                return args.crdtAlgorithm.merge(args.tree);
            }
            else if (isStandardCrdtAlgorithm(args.crdtAlgorithm)) {
                return {
                    action: 'set',
                    value: await args.crdtAlgorithm.merge(args.tree, args.valueType)
                };
            }
            else {
                throw new Error(`Algorithm ${args.crdtAlgorithm.id} is of incorrect type. Expected "ReferenceToObject" ot "Standard" type, found ${args.crdtAlgorithm.algoType}`);
            }
        },
        referenceToId: standardMerge,
        referenceToClob: standardMerge,
        referenceToBlob: standardMerge,
        map: standardMerge,
        mapEntry: optionalValueMerge,
        bag: standardMerge,
        array: standardMerge,
        set: standardMerge,
        object: standardMerge,
        objectProperty: optionalValueMerge,
        stringifiable: standardMerge
    });
    MessageBus.send('log', `merge version nodes ${firstNodeHash} and ${secondNodeHash} of type ${type} done`);
    return {
        alreadyMerged: false,
        result,
        tree
    };
}
async function standardMerge(args) {
    MessageBus.send('debug', `merge ${args.path} [${args.valueType.type}] with algorithm ${args.crdtAlgorithm.id}`);
    if (!isStandardCrdtAlgorithm(args.crdtAlgorithm)) {
        throw new Error(`Algorithm ${args.crdtAlgorithm.id} is of incorrect type. Expected "Standard" type, found ${args.crdtAlgorithm.algoType}`);
    }
    return args.crdtAlgorithm.merge(args.tree, args.valueType);
}
async function optionalValueMerge(args) {
    MessageBus.send('debug', `merge ${args.path} [${args.valueType.type}] with algorithm ${args.crdtAlgorithm.id}`);
    if (!isOptionalValueCrdtAlgorithm(args.crdtAlgorithm)) {
        throw new Error(`Algorithm ${args.crdtAlgorithm.id} is of incorrect type. Expected "OptionalValue" type, found ${args.crdtAlgorithm.algoType}`);
    }
    return args.crdtAlgorithm.merge(args.tree);
}
//# sourceMappingURL=merge-objects.js.map